import React from 'react';
import { SearchInput } from '@features/SearchInput';
import { useOrderTable } from '../../lib';
import './OrderTableFilters.scss';
import { Button, Select } from '@shared/UI';
import { ReactComponent as FilterIcon } from '../../../../shared/assets/svgs/FilterIcon.svg';
import { TradeOrderModal } from '../TradeOrderModal';
import { useModal } from '@features/Modal';

interface IOrderTableFilters {
    onAssignPositionClick: (order: any) => void;
}

export const OrderTableFilters: React.FC<IOrderTableFilters> = ({ onAssignPositionClick }) => {
    const { setOrderIdentifier, orderStatus, setOrderStatus, orderType, setOrderType, riaScreen } = useOrderTable();
    const userStorage = localStorage.getItem('User');
    let userObject = JSON.parse(userStorage ? userStorage : '');

    const { open: openTradeOrderModal } = useModal(TradeOrderModal);

    const onopenTradeOrderModal = () => {
        openTradeOrderModal({});
    };

    const statusSelectOptions = [
        { label: 'Assigned', value: 'Assigned' },
        { label: 'Un-Assigned', value: 'Un-Assigned' },
    ];

    const TypeSelectOptions = [
        { label: 'Buy', value: 'Buy' },
        { label: 'Sell', value: 'Sell' },
    ];

    const filterIcon = <FilterIcon />;

    return (
        <div className='widget-trade-status-table-filters'>
            <SearchInput
                setValue={setOrderIdentifier}
                placeholder='Search'
            />
            {riaScreen && (
                <Select
                    allowClear
                    currentValue={orderStatus}
                    options={statusSelectOptions}
                    placeholder='Status'
                    prefixIcon={filterIcon}
                    onSelect={setOrderStatus}
                    inputWrapperClassName='widget-dtc-reports-table-filters select filter-status'
                />
            )}
            <Select
                allowClear
                currentValue={orderType}
                options={TypeSelectOptions}
                placeholder='Type'
                prefixIcon={filterIcon}
                onSelect={setOrderType}
                inputWrapperClassName='widget-dtc-reports-table-filters select filter-status'
            />
            {userObject && (
                <>
                    <Button
                        className='assign-securities-button'
                        onClick={() => onopenTradeOrderModal()}
                    >
                        Request Trade
                    </Button>
                    <Button
                        className='assign-securities-button'
                        onClick={() => onAssignPositionClick(null)}
                    >
                        Assign Securities
                    </Button>
                </>
            )}
        </div>
    );
};
